export default "1325e947c753850b.svg"